<template>
    <div class="trial-act">
        <van-swipe v-if="list.length > 0" :loop="false" :show-indicators="false" :width="630 * widthSale" @change="onSwipeChange">
            <van-swipe-item v-for="(item,index) in list" :key="index">
                <div :class="['act-item',{'item-one':list.length==1}]">
                    <p class="act-tt">{{item.name}}</p>
                    <span class="act-desc">{{item.remark}}</span>
                    <div class="act-disc"  @touchstart.stop="stop">
                        <span v-for="(it,i) in item.discountLadderSettingStringList" :key="i">{{it}}</span>
                    </div>
                    <p class="act-cmpt">收银计算：商品收银（{{getLabel(item.singleEraseMode)}}）收银总金额（{{getLabel(item.totalEraseMode)}}）</p>
                </div>
            </van-swipe-item>
        </van-swipe>
    </div>
</template>
<script>
export default {
    props: {
        list: {
            default: function() {
                return []
            },
            type: Array
        }
    },
    data() {
        return {
            widthSale: window.innerWidth / 750,
            index: 0,
            mlOptions: [
                { value: 0, label: '实收' },
                { value: 1, label: '抹掉个位元' },
                { value: 2, label: '抹掉角' },
                { value: 3, label: '四舍五入到元' },
                { value: 4, label: '进位到元' },
                { value: 5, label: '抹掉分' },
                { value: 6, label: '四舍五入到角' },
                { value: 7, label: '进位到角' }
            ]
        }
    },
    methods: {
        stop() {
            // a.stopPropagation()
        },
        onSwipeChange(val) {
            this.index = val
            this.$emit('swipe', val)
        },
        getLabel(mode) {
            return this.mlOptions.find(item=>item.value ==mode) && this.mlOptions.find(item=>item.value ==mode).label || ''
        },
    }
}
</script>
<style lang="less" scoped>
.trial-act {
    // display: flex;
    // overflow-x: auto;
    margin: 10px 0;
    // &::-webkit-scrollbar{
    //     display: none;
    // }
    .act-item.item-one {
        width: 730px;
    }
    .act-item {
        width: 610px;
        height: 100%;
        border-radius: 10px;
        background-color: #fff;
        flex-shrink: 0;
        padding: 30px;
        box-sizing: border-box;
        margin: 0 10px;
        .act-cmpt, .act-tt, .act-desc {
            height: 40px;
            font-size: 24px;
            line-height: 40px;
            font-weight: 500;
        }
        .act-cmpt {
            font-size: 20px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }
        .act-tt {
            font-size: 28px;
        }
        .act-desc {
            display: block;
            font-weight: 400;
            margin: 10px 0;
        }
        .act-disc {
            display: flex;
            flex-wrap: nowrap;
            margin-bottom: 20px;
            overflow-x: auto;
            &::-webkit-scrollbar {
                display: none;
            }

            span {
                flex-shrink: 0;
                display: inline-block;
                // width: 140px;
                padding: 0 20px;
                height: 50px;
                text-align: center;
                line-height: 50px;
                background-color: #ffe7e6;
                border-radius: 10px;
                font-size: 24px;
                color: #ED3939;
                font-weight: 500;
                
                &:not(:last-child){
                    margin-right: 20px;
                }
            }
        }
    }
}
</style>